import TWEEN from "@tweenjs/tween.js"
import * as THREE from "three";

function ExplodeModel(scene) {
    this._init_(scene)
}
ExplodeModel.prototype = {
    constructor: ExplodeModel,
    _init_: function (scene) {
        this.scene = scene;
        this.scene.children.forEach((child)=>{
            if(child.name==="外部加载的模型"){
              this.model=child;
            }
          });
        this.objInfos={};
        this.meshConut=0;
        this.meshBox3=new THREE.Box3();
        if(this.model)
        this.model.traverse((child)=>{
            if(child.isMesh){
                this.meshConut+=1;
                let id=child.ID;
                let originPosition=child.position;
                child.userData.originPosition={x:originPosition.x,y:originPosition.y,z:originPosition.z};
                this.meshBox3.setFromObject(child);
                //获取每个mesh的中心点，爆炸方向为爆炸中心点指向mesh中心点
                var worldPs = new THREE.Vector3().addVectors(this.meshBox3.max, this.meshBox3.min).multiplyScalar(0.5);
                if(isNaN(worldPs.x))return;
                //计算爆炸位置
                var newPosition=new THREE.Vector3().subVectors(worldPs, new THREE.Vector3(0,0,0)).multiplyScalar(4);
                child.userData.explodePosition=newPosition;
            }
        });
        this.inited=true;
    },
    explode:function(){
        if(!this.inited){
            this.$message.info("请等待模型加载完再重试");
            return;
        }
       this.model.traverse((child)=>{
           if(child.isMesh){
            this.animateModel(child.userData.originPosition,child.userData.explodePosition,this.callBack,child);
           }
        })
    },
    animateModel:function(oldP,newP,callBack,mesh){
        var tween=new TWEEN.Tween({
            x1:oldP.x,
            y1:oldP.y,
            z1:oldP.z
        });
        tween.to({
            x1:newP.x,
            y1:newP.y,
            z1:newP.z
        },1000);
        tween.onUpdate((object)=>{
            mesh.position.set(object.x1,object.y1,object.z1);
        });
        tween.onComplete(()=>{
            callBack&&callBack();
        });
        tween.easing(TWEEN.Easing.Cubic.InOut);
        tween.start();
    },

    callBack:function(){
        console.log("动画完成回调");
    },
    tweenanimate:function(time) {
        return TWEEN.update(time);
    },

    resetExplode:function(){
        if(!this.inited){
            this.$message.info("请等待模型加载完再重试");
            return;
        }
       this.model.traverse((child)=>{
           if(child.isMesh){
            this.animateModel(child.userData.explodePosition,child.userData.originPosition,this.callBack,child);
           }
        })
    }
}

export {
    ExplodeModel
}